module.exports = __webpack_public_path__ + "static/media/right_layout_image_Car.7ce442c6.svg";